// ** MUI Imports

// ** Type Import
import { Settings } from 'src/@core/context/settingsContext'

// ** Components
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
import NotificationDropdown from '../../../@core/layouts/components/shared-components/NotificationDropdown'
import {Button, Grid, Stack} from '@mui/material'
import EmpresaSelect from "../../../@core/layouts/components/horizontal/app-bar-content/EmpresaSelect";
import NewCompany from "../../../@core/layouts/components/horizontal/app-bar-content/NewCompany";
import {CompanyContext, CompanyContextValue} from "../../../pages/solicitation-new/context/companyContext";
import {useContext, useEffect, useState} from "react";
import {ClientNotification, ClientUserDTO} from "../../../types/client/clientData";
import {HttpOnboarding} from "../../../http/onboarding/httpOnboarding";
import {HttpClientUser} from "../../../http/client/httpClientUser";
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';

interface Props {
  settings: Settings
  saveSettings: (values: Settings) => void
}
const AppBarContent = (props: Props) => {
  // ** Props
  const { settings } = props
    
  const {clientId} = useContext<CompanyContextValue>(CompanyContext)
  const [notifications, setNotifications] = useState<ClientNotification[]>()
  const [companies, setCompanies] = useState<ClientUserDTO[]>()
    
  useEffect(() => {
      if (clientId !== 0) {
          HttpOnboarding.getNotificationsSummary(clientId).then((r) => setNotifications(r))
      }
      HttpClientUser.getCompanies()
          .then(companies => {
              setCompanies(companies)
          })
  }, [clientId])

    const onDownloadManual = (): void => {
        const fileName = "instructivo_onboarding.pdf";
        const fileUrl = `${window.location.origin}/instructivo.pdf`;

        try {
            downloadFile(fileUrl, fileName);
        } catch (error) {
            console.error('Error al descargar el manual:', error);
            alert('Error al descargar el manual. Por favor, inténtelo de nuevo más tarde.');
        }
    };
    
    const downloadFile = (url: string, customFileName?: string): void => {
        const link = document.createElement('a');
        link.href = url;

        if (customFileName) {
            link.download = customFileName;
        } else {
            const urlParts = url.split('/');
            link.download = urlParts[urlParts.length - 1];
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
  return (
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{width:'100%', height: '100%', 
          p: 4,
          backgroundColor: 'white', 
          boxShadow: '0px 5px 6px -3px rgba(58, 53, 65, 0.2), 0px 9px 12px 1px rgba(58, 53, 65, 0.14), 0px 3px 16px 2px rgba(58, 53, 65, 0.12)'
      }}>
          <Grid container alignItems='center'>
              <Grid md={3}>
                  <EmpresaSelect companies={companies}/>
              </Grid>
              <Grid md={9} pl={3}>
                <NewCompany hasCompany={companies?.length !== 0}/>
              </Grid>
          </Grid>
          <>
              <Button color='primary' variant='contained' onClick={onDownloadManual} endIcon={<SimCardDownloadIcon />} size='small' sx={{width: '280px'}}>
                  Descargá el instructivo
              </Button>
              {notifications && <NotificationDropdown settings={settings} notifications={notifications} />}
              <UserDropdown settings={settings} />
          </>
      </Stack>
  )
}

export default AppBarContent
